module.exports = __webpack_public_path__ + "img/05.3ea1a838.png";